import { searchQueryKeyMap } from '@/features/search/_utils/query-keys';

export const queryKeyMap = {
  projectAnalysis: searchQueryKeyMap.projectAnalysis,
  projectCrossAnalysis: (params?: object) =>
    ['projectCrossAnalysis', params].filter((item) => item !== undefined),
  unfoldAnalysisData: (params?: object) =>
    ['unfoldAnalysis', params].filter((item) => item !== undefined),
};
